/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import { HELPERS } from '../../helpers/index.js';
import type { SetGiftIndexingEnabledResponse, SetGiftIndexingEnabledVars } from '../openapi-types.gen.js';

export type { SetGiftIndexingEnabledResponse, SetGiftIndexingEnabledVars } from '../openapi-types.gen.js';

export const useSetGiftIndexingEnabled = createMutationHook<SetGiftIndexingEnabledVars, SetGiftIndexingEnabledResponse, unknown>({
  specName: 'useSetGiftIndexingEnabled',
  path: '/v1/users/me/gift-indexing-enabled',
  method: 'PATCH',
  resolveUrl: (vars: SetGiftIndexingEnabledVars) => `/v1/users/me/gift-indexing-enabled`,
  buildBody: (vars: SetGiftIndexingEnabledVars) => ({ enabled: vars.enabled }),
  parseResponse: (raw: unknown): SetGiftIndexingEnabledResponse => raw as SetGiftIndexingEnabledResponse,
  optimistic: [{
    queryKey: ['accounts', 'viewer'],
    reconcile: false,
    entityGraph: true,
    apply: (prev: any, vars: SetGiftIndexingEnabledVars, queryKey: readonly unknown[], queryClient: any, viewerScope: string, networkScope: string) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      next = (HELPERS.applyPrivateAccountGiftIndexingOptimistic as unknown as (prev: any, vars: SetGiftIndexingEnabledVars, queryKey: readonly unknown[], queryClient: any, viewerScope: string, networkScope: string) => any)(next, vars, queryKey, queryClient, viewerScope, networkScope);
      return next;
    },
  }],
  
  
});
